<template>
  <footer
    class="w-full h-auto bg-primary px-[20px] md:px-[30px] lg:px-40 py-10 flex flex-col justify-between text-white font-sans relative bottom-0"
  >
    <div class="flex lg:gap-20 gap-8 flex-wrap mb-8">
      <div class="flex flex-col gap-3 min-w-[200px]">
        <h3 class="text-lg font-semibold mb-1">Company</h3>
        <p class="text-sm leading-relaxed">
          FutureRent<br />
          9 Boundary Rd, Century City,<br />
          Cape Town, 7441<br />
          South Africa
        </p>
        <p class="text-sm mt-2">
          Email:
          <a href="mailto:care@futurerent.co.za" class="underline"
            >care@futurerent.co.za</a
          ><br />
          Phone:
          <a href="tel:+2787 265 0918" class="underline">+27 87 265 0918</a>
        </p>
      </div>

      <div class="flex flex-col gap-3 min-w-[200px]">
        <h3 class="text-lg font-semibold mb-1">Links</h3>

        <router-link
          v-for="(item, i) in navItems"
          :key="i"
          :to="item.to"
          class="text-sm leading-relaxed"
        >
          {{ item.title }}
        </router-link>
      </div>
      <div class="flex flex-col gap-3 min-w-[200px]">
        <h3 class="text-lg font-semibold mb-1">Legal</h3>

        <router-link
          v-for="(item, i) in legalItems"
          :key="i"
          :to="item.to"
          class="text-sm leading-relaxed"
        >
          {{ item.title }}
        </router-link>
      </div>

      <div class="flex flex-col gap-3 min-w-[200px]">
        <h3 class="text-lg font-semibold mb-1">Connect with us</h3>
        <div class="flex gap-4 items-center mt-1">
          <a
            href="https://api.whatsapp.com/send?phone=27872650918&amp;text=Link%3A%0Ahttps%3A%2F%2Ffb.me%2F4H5XQJAnG%0A%0AHello%21+Can+I+get+more+info+on+this%3F&amp;source_url=https%3A%2F%2Ffb.me%2F4H5XQJAnG&amp;icebreaker=Hello%21+Can+I+get+more+info+on+this%3F&amp;app=facebook&amp;entry_point=post_cta&amp;jid=27872650918%40s.whatsapp.net&amp;show_keyboard=1&amp;show_ad_attribution=1&amp;source=FB_Post&amp;context=ARDaTylezR_XoiBUK0Xv0xddR18UuVfmGXdblz-9Ey_N-mtk96f4zFO_PpwXBJVFsAYbiUHepjOvRYkDC9deboeXDTML5fz8iDfCrIhcRnayV6zpnnrVsH0vJnpzeWMORrnM16l2rzgfnv0Ijiq-9nu2ge_NW6PAlm-ZNgFIeBKMOGoI-YB7VBtXgLY2MW6JcZSZNzDbTDpXAyeTfWJ7zPtwZt9VfKyi79FPCK8d8o7-pRsjB1ovkkFDuw0fJnbguNlOgyzvMUzmol98X70Quy602KmhW_GPKrRSct_M4lkj8vKq4f5JTLLiQzwjb8A6chCUVk39C8dZY51yifJ3HQT7DOse8YWkd2QYZ4Ci&amp;token=eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjEyNSJ9.eyJleHAiOjE3MjQyNDkyNTAsInBob25lIjoiMjc4NzI2NTA5MTgiLCJ0ZXh0IjoiTGluazpcbmh0dHBzOlwvXC9mYi5tZVwvNEg1WFFKQW5HXG5cbkhlbGxvISBDYW4gSSBnZXQgbW9yZSBpbmZvIG9uIHRoaXM_Iiwic291cmNlX3VybCI6Imh0dHBzOlwvXC9mYi5tZVwvNEg1WFFKQW5HIiwiaWNlYnJlYWtlciI6IkhlbGxvISBDYW4gSSBnZXQgbW9yZSBpbmZvIG9uIHRoaXM_IiwiYXBwIjoiZmFjZWJvb2siLCJlbnRyeV9wb2ludCI6InBvc3RfY3RhIiwiamlkIjoiMjc4NzI2NTA5MThcdTAwNDBzLndoYXRzYXBwLm5ldCIsInNob3dfa2V5Ym9hcmQiOjEsInNob3dfYWRfYXR0cmlidXRpb24iOjEsInNvdXJjZSI6IkZCX1Bvc3QifQ.mafjk-uo3bx7pihi8wWqGnFMZgC8jQCFV2gCWHVLa69dC0UigvtgYUww9iZMzl778XrY-N7H3nTN7XhdUCIJbw&amp;fbclid=IwY2xjawExgndleHRuA2FlbQIxMAABHRMg_Q2NTtKOkdQR6HhjaCm2iPslnBQrEv0EakxG2b6Ykx3pntQXev6CTQ_aem_m7wKZaRAA89bE-uO2PALtw"
            target="_blank"
            class="hover:text-[#CED4E7]"
            referrerpolicy="origin"
          >
            <PhWhatsappLogo size="25" />
          </a>
          <a
            href="https://www.facebook.com/futurerent"
            target="_blank"
            class="hover:text-[#CED4E7]"
            referrerpolicy="origin"
          >
            <PhFacebookLogo size="25" />
          </a>
          <a
            href="https://www.instagram.com/futurerentza/?hl=en"
            target="_blank"
            class="hover:text-[#CED4E7]"
            referrerpolicy="origin"
          >
            <PhInstagramLogo size="25" />
          </a>
          <a
            href="https://www.tiktok.com/@futurerentza"
            target="_blank"
            class="hover:text-[#CED4E7]"
            referrerpolicy="origin"
          >
            <PhTiktokLogo size="25" />
          </a>
          <a
            href="https://www.linkedin.com/company/futurerentza"
            target="_blank"
            class="hover:text-[#CED4E7]"
            referrerpolicy="origin"
          >
            <PhLinkedinLogo size="25" />
          </a>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-3 text-white border-b border-white py-2">
      <CompanyLogo width="150" height="30" />
      <div class="flex gap-1 text-yellow-400">
        <component
          v-for="i in fullStars"
          :key="'full-' + i"
          :is="PhStar"
          :weight="'fill'"
          size="20"
        />
        <component
          v-if="hasHalfStar"
          :is="PhStarHalf"
          weight="fill"
          size="20"
        />
        <component
          v-for="i in emptyStars"
          :key="'empty-' + i"
          :is="PhStar"
          :weight="'regular'"
          size="20"
        />
      </div>
      <span class="text-[8px] lg:text-sm"
        >Rated {{ googleRating }} on <b>Google</b></span
      >
      <a
        href="https://www.google.com/search?sca_esv=4c0b4ca658e05210&sxsrf=AE3TifPlAEgN63IjZy7Wjz0AbqYd_Z5faQ:1750918598753&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E9y6EZwpd7fy8RKs2PBKTySZj3olEe2Tg7fvIIA10e-8EpuJ5z7UYtaQ5qS9-XBMYJ_Dg1PSq4uyQyBc18hCGD_yX4o7&q=FutureRent+Reviews&sa=X&ved=2ahUKEwi30e-IuI6OAxVuhq8BHfJHKYMQ0bkNegQINBAE&biw=1440&bih=812&dpr=2"
        target="_blank"
        class="text-sm underline hover:text-[#CED4E7] block lg:hidden"
      >
        View reviews
      </a>
    </div>
  </footer>
</template>

<script setup>
import { computed, ref } from "vue";
import {
  PhFacebookLogo,
  PhInstagramLogo,
  PhLinkedinLogo,
  PhWhatsappLogo,
  PhStar,
  PhStarHalf,
  PhTiktokLogo,
} from "@phosphor-icons/vue";
import CompanyLogo from "./CompanyLogo.vue";

const googleRating = ref(4.6);

const fullStars = computed(() => Math.floor(googleRating.value));
const hasHalfStar = computed(
  () => googleRating.value % 1 >= 0.25 && googleRating.value % 1 < 0.75
);
const emptyStars = computed(
  () => 5 - fullStars.value - (hasHalfStar.value ? 1 : 0)
);

const navItems = [
  { title: "How it Works?", to: "/#how_it_works" },
  { title: "About Us", to: "/about-us" },
  { title: "FAQ's", to: "/faqs" },
  // { title: "MarketPlace", to: "/market-place" },
];
const legalItems = [
  { title: "Terms & Conditions", to: { path: "/Ts&Cs" } },
  // { title: "Competition T's & C's", to: { path: "/win-a-car/Ts&Cs" } },
];
</script>
